export default "__VITE_ASSET__C45cCns4__"